import React from "react";
import { Img, Heading, Text } from "../../components";

export default function TechnologyExpertiseSection() {
  const icons = [
    {
      src: "images/react.svg",
      alt: "PHP Logo",
      style: { top: "10%", left: "46%" },
    },
    {
      src: "images/nodejs.svg",
      alt: "GitLab Logo",
      style: { top: "10%", left: "54%" },
    },
    {
      src: "images/jira.svg",
      alt: "Jira Logo",
      style: { top: "20%", left: "19%" },
    },
    {
      src: "images/angular.svg",
      alt: "Angular Logo",
      style: { top: "20%", left: "37%" },
    },
    {
      src: "images/android.svg",
      alt: "Android Logo",
      style: { top: "20%", left: "63%" },
    },
    {
      src: "images/aws.svg",
      alt: "AWS Logo",
      style: { top: "20%", left: "81%" },
    },
    {
      src: "images/python.svg",
      alt: "Python Logo",
      style: { top: "30%", left: "28%" },
    },
    {
      src: "images/html5.svg",
      alt: "HTML5 Logo",
      style: { top: "30%", left: "10%" },
    },
    {
      src: "images/github.svg",
      alt: "GitHub Logo",
      style: { top: "30%", left: "72%" },
    },
    {
      src: "images/mongodb.svg",
      alt: "MongoDB Logo",
      style: { top: "30%", left: "90%" },
    },
    {
      src: "images/php.svg",
      alt: "React Logo",
      style: { top: "60%", left: "10%" },
    },
    {
      src: "images/gitlab.svg",
      alt: "Node.js Logo",
      style: { top: "50%", left: "19%" },
    },
    {
      src: "images/figma.svg",
      alt: "Figma Logo",
      style: { top: "60%", left: "90%" },
    },
    {
      src: "images/analytics.svg",
      alt: "Google Analytics Logo",
      style: { top: "50%", left: "81%" },
    },
  ];

  return (
    <div className="mt-20 md:mb-[200px] flex flex-col items-center bg-white">
      {/* Section Heading */}
      <Heading
        size="headingxl"
        as="h2"
        className="mb-8 text-center text-[90px] font-medium uppercase  tracking-[-1.92px] text-gray-950 xl:text-[76px] lg:text-[66px] md:text-[48px] sm:text-[40px]"
      >
        TECHNOLOGY
        <br />
        EXPERTISE
      </Heading>

      {/* Icon Container */}
      <div
        className="relative"
        style={{
          width: "80%",
          height: "500px",
          position: "relative",
        }}
      >
        {icons.map((icon, index) => (
          <div
            key={index}
            className="absolute flex h-[100px] w-[100px] xl:h-[80px] xl:w-[80px] lg:h-[70px] lg:w-[70px] items-center justify-center rounded-[20px] bg-white-a700 shadow-md md:hidden sm:hidden"
            style={{
              ...icon.style,
              transform: "translate(-50%, -50%)",
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
            }}
          >
            <Img
              src={icon.src}
              alt={icon.alt}
              className="h-[200px] w-auto"
            />
          </div>
        ))}
        <div className="grid md:grid-cols-3 sm:grid-cols-3 gap-6 md:px-[160px] sm:px-[40px] lg:hidden xl:hidden 2xl:hidden">
          {icons.map((icon, index) => (
            <div
              key={index}
              className="flex h-[80px] w-[80px] sm:h-[60px] sm:w-[60px] items-center justify-center rounded-[20px] bg-white shadow-md"
              style={{
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Img src={icon.src} alt={icon.alt} className="h-[40px] w-auto" />
            </div>
          ))}
        </div>
        <div className="lg:pt-[300px] xl:pt-[300px] 2xl:pt-[300px] md:pt-[20px] sm:pt-[20px]">
          <Text
            size="textxl"
            as="p"
            className="text-center text-[24px] font-light leading-9 tracking-[-0.6px] text-gray-600 lg:text-[20px] md:text-[16px] sm:text-[16px]"
          >
            {/* Referral programs, push notifications, social sharing, payment{" "}
            <br className="sm:hidden"/> gateways, A/B testing, desktop editors, mobile apps */}
             Delivering seamless integrations, engagement tools, and <br/>scalable solutions for growth.
          </Text>

          {/* Footer Heading */}
          <Heading
            size="text4xl"
            as="h3"
            className="mt-8 md:mt-5 sm:mt-2 text-center text-[40px] font-medium tracking-[-0.6px] text-gray-600 lg:text-[34px] md:text-[24px] sm:text-[20px] uppercase"
          >
            Web - Mobile - APIs - DevOps - Cloud
          </Heading>
        </div>
      </div>

      {/* Description */}
    </div>
  );
}
